import { render, staticRenderFns } from "./transitioned-router.vue?vue&type=template&id=9b9b3df0&"
import script from "./transitioned-router.vue?vue&type=script&lang=js&"
export * from "./transitioned-router.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports